const ReimbursementStatusEnum = Object.freeze({
	REQUESTED: 'Requested',
	DECLINED: 'Declined',
	APPROVED: 'Approved',
	INVOICED: 'Invoiced',
	PAID: 'Paid',
});

export default ReimbursementStatusEnum;
